import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const selfCalendervds = Loadable(() => import('../../containers/web/selfCalendervds'));

export default MapTo('vcg/components/soe-home/react/selfCalendervds')(selfCalendervds);
